import { createFileRoute } from '@tanstack/react-router';
import { Sparkles } from 'lucide-react';
import { AiUsageReport, HostedAiCard } from '@/components/ai/admin-ai';
import { PageHeader } from '@/components/page-header';

export const Route = createFileRoute('/_app/admin/ai')({ component: AdminAiPage });

function AdminAiPage() {
  return (
    <div className="mx-auto w-full max-w-5xl">
      <PageHeader
        title="AI"
        icon={Sparkles}
        description="Hosted AI for this panel, its limits, and how much is used."
      />
      <div className="grid gap-8">
        <HostedAiCard />
        <AiUsageReport />
      </div>
    </div>
  );
}
